module.exports = __webpack_public_path__ + "img/img (31).8245061b.jpg";